import merge from 'lodash/merge';

import con, { mutationTypes } from './mutationTypes';

export default class PluggableModule {
  constructor(name, moduleName = name + 's') {
    this._meta = {
      name,
      moduleName
    };

    mutationTypes.addModule(moduleName, true);
  }

  get name() {
    return this._meta.name;
  }

  get moduleName() {
    return this._meta.moduleName;
  }

  get con() {
    return con;
  }

  extend(obj) {
    return merge(this, obj);
  }

  addMutationTypes(mutations) {
    mutationTypes.add(this.moduleName, mutations);
  }
}
